import { useSelector } from "react-redux";
import { selectShouldShowLocaleSwitcherAdminECM } from "../../app/dataServiceFeatureFlagsSlice";

/**
 * Custom hook to manage the locale switcher feature flag
 * Reads `shouldShowLocaleSwitcherAdminECM` from the dataservice /features API.
 * @returns Whether the locale switcher is enabled
 */
export const useLocaleSwitcherFeatureFlag = (): boolean => {
    return useSelector(selectShouldShowLocaleSwitcherAdminECM);
};
